"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    format: ()=>format,
    getMessage: ()=>getMessage
});
const _get = /*#__PURE__*/ _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const format = (str, values)=>{
    const args = Object.entries(values);
    for (const [key, value] of args){
        str = str?.replace(new RegExp(`\\{${key}\\}`, 'gi'), value);
    }
    return str;
};
const getMessage = (lang, reach, values)=>{
    const str = (0, _get.default)(lang, reach);
    return format(str, values || []);
};
